import APIError from '../APIError';

// TODO: Add errors when the endpoint is upgraded to v2
class SecondaryMarketPropertyError extends APIError {
  constructor(code, details = null) {
    super(code, 'SecondaryMarketPropertyError', details);
  }
}

export default SecondaryMarketPropertyError;
